export interface TBuildRowCountInput {
    total: number;
    totalUnfiltered: number | null | undefined;
    hasActiveFilters: boolean;
}
export function buildRowCount({ total, totalUnfiltered, hasActiveFilters }: TBuildRowCountInput) {
    const grand = totalUnfiltered ?? total;
    const isFiltered = hasActiveFilters || (totalUnfiltered != null && total !== totalUnfiltered);
    return { filtered: total, total: grand, isFiltered };
}
